import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PaginationUtil } from 'src/app/common/util';
import { PaginationModel } from 'src/app/models/pagination.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { ProductService } from 'src/app/services/product.service';

@Component({
  selector: 'app-associated-products-report',
  templateUrl: './associated-products-report.component.html',
  styleUrls: ['./associated-products-report.component.scss']
})
export class AssociatedProductsReportComponent implements OnInit {
  failedStart = false;
  productOrigin = null;
  productAssociated = null;
  associated: ProductResponse[] = [];
  filterAssociated = "";
  paginationProducts = new PaginationModel(0, 5, 0, 0, [], []);
  @ViewChild('svgContainer', { static: true }) svgContainer: ElementRef;

  constructor(
    private toastService: ToastrService,
    private productService: ProductService
  ) {

  }

  ngOnInit(): void {
    this.getIdAssociatedProducts();
  }

  getIdAssociatedProducts() {
    this.failedStart = false;
    this.productService.getIdAssociatedProducts().subscribe({
      next: (response: ResponseObject) => {
        this.paginationProducts.total = response.data;
        this.paginationProducts = PaginationUtil.reset(this.paginationProducts);
      },
      error: (error) => {
        this.failedStart = true;
        this.toastService.error("Error al obtener los productos asociados");
      }
    })
  }


  filter() {
    this.productOrigin = null;
    this.associated = [];
    var lowercase = this.filterAssociated ? this.filterAssociated.toLowerCase() : "";
    this.paginationProducts.filter = this.paginationProducts.total.filter((product: ProductResponse) => {
      return product.name?.toLowerCase().includes(lowercase) || product.code?.toLowerCase().includes(lowercase);
    });
    this.drawLink();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.drawLink();
  }

  selectRow(product: ProductResponse) {
    var code = product.code;
    this.productOrigin = code;
    this.associated = [];
    if (!product.associates) {
      this.productService.getAssociatedProductsByCode(
        code
      ).subscribe({
        next: (response: ResponseObject) => {
          product.associates = response.data;
          this.associated = response.data;
          setTimeout(() => {
            this.drawLink();
          }, 50);
        },
        error: (error) => {
          this.toastService.error("Error al obtener los productos asociados");
        }
      })
    } else {
      this.associated = product.associates;
      setTimeout(() => {
        this.drawLink();
      }, 50);
    }
  }

  drawLink() {
    if (this.productOrigin && this.associated.length > 0) {
      setTimeout(() => {
        const svg = this.svgContainer.nativeElement as SVGElement;
        svg.innerHTML = ''; // Clear previous lines

        const table1Row = document.querySelector(`#table-products tr.selected`);
        const tableRows = document.querySelectorAll(`#table-associated tr.selected`);
        tableRows.forEach((table2Row) => {
          if (table1Row && table2Row) {
            const rect1 = table1Row.getBoundingClientRect();
            const rect2 = table2Row.getBoundingClientRect();

            const parentRect = svg.parentElement.getBoundingClientRect();

            const x1 = rect1.right - parentRect.left - 12;
            const y1 = rect1.top + rect1.height / 2 - parentRect.top;
            const x2 = rect2.left - parentRect.left - 12;
            const y2 = rect2.top + rect2.height / 2 - parentRect.top;
            const xMiddle = x1 + ((x2 - x1) / 2);

            this.drawLine(svg, x1, xMiddle, y1, y1);
            this.drawLine(svg, xMiddle, x2, y2, y2);
            this.drawLine(svg, xMiddle, xMiddle, y1, y2);
          }
        })
      }, 50);
    } else {
      const svg = this.svgContainer.nativeElement as SVGElement;
      svg.innerHTML = ''; // Clear previous lines
    }
  }

  drawLine(svg, x1, x2, y1, y2) {
    const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', x1.toString());
    line.setAttribute('y1', y1.toString());
    line.setAttribute('x2', x2.toString());
    line.setAttribute('y2', y2.toString());
    line.setAttribute('stroke', '#001f54');
    line.setAttribute('stroke-width', '2');
    svg.appendChild(line);
  }
}
